<app-dossier eyebrow="Contrôle d'identité // Échec" reference="Niveau requis : 2" [decor]="false">
  <app-page-title
    title="Accès refusé"
    lede="Votre accréditation ne permet pas d'ouvrir ce dossier."
  />
  <p class="center spaced"><span class="stamp stamp--large">Accès refusé</span></p>

  <section class="card spaced" aria-labelledby="help-title">
    <img class="paperclip paperclip--small" src="/assets/paperclip.svg" alt="" />
    <div class="card__header">
      <h2 class="card__title" id="help-title">Procédure de secours</h2>
    </div>
    <p class="text-small">
      Vous êtes agent et vous avez perdu l'accès à votre mission (téléphone changé, données
      effacées) ? Demandez à l'organisateur de vous remettre un nouvel accès : il vous présentera un
      code à scanner.
    </p>
  </section>

  <div class="dossier__footer button-row">
    <a class="button button--secondary" routerLink="/">Retour au point de contact</a>
    <a class="button button--primary" routerLink="/login">Se connecter</a>
  </div>
</app-dossier>
